import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const EmptyCart = () => {
	const navigate = useNavigate();

	return (
		<Stack className='filterbg' alignItems='center' sx={{ pt: { xs: 12, md: 17 }, pb: 18 }}>
			<Box
				sx={{
					border: 2,
					borderColor: 'secondary.main',
					borderRadius: 5,
					width: { xs: '90%', md: '80%', lg: '70%', xl: '65%' },
					height: '550px'
				}}
				className='togglebg'
			>
				<Stack
					className='filter'
					alignItems='center'
					sx={{ mt: { xs: 5, sm: 10 } }}
					spacing={4}
					px={3}
				>
					<ShoppingCartOutlinedIcon
						sx={{
							fontSize: { xs: '50px', md: '100px', xl: '150px' },
							color: 'secondary.main'
						}}
					/>
					<Typography variant='h1' sx={{ fontSize: { xs: '1.5em', md: '2.3em' } }}>
						YOUR CART IS EMPTY
					</Typography>
					<Typography>
						Before proceeding to checkout, you must add some Gift Cards to the Cart.
					</Typography>
					<Button
						onClick={() => navigate('/')}
						sx={{
							textTransform: 'none',
							borderRadius: (theme) => theme.pixels.bRadius.main,
							boxShadow: 'none',
							padding: '10px 25px',
							fontWeight: 600
						}}
					>
						Continue Shopping
					</Button>
				</Stack>
			</Box>
		</Stack>
	);
};

export default EmptyCart;
